'use strict';

var React = require('react');

var SvgBuyButtonButtonLayoutMajor = function SvgBuyButtonButtonLayoutMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h1v-2h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h2v-1zm-2 7a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8h-10a4 4 0 0 1-4-4zm16-6v-1h-1v-2h1.5a1.5 1.5 0 0 1 1.5 1.5v1.5h-2zm0 13h-1v2h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.5h-2v1zm-14-1v1h1v2h-1.5a1.5 1.5 0 0 1-1.5-1.5v-1.5h2zm6 3h-3v-2h3v2zm2 0h3v-2h-3v2zm-2-16h-3v-2h3v2zm2 0h3v-2h-3v2z"
  }));
};

exports.SvgBuyButtonButtonLayoutMajor = SvgBuyButtonButtonLayoutMajor;
